import GeneralServices from "./GeneralServices";

class RevaluationsServices {

  getProductRevaluations = async (args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: args.setLoading,
        loader: args.loader === false ? false : true,
        endpoint: `revaluations?productId=${args.productId}`,
      });
      return response.data;
    } catch (err) {
      return [];
    }
  };

}

export default new RevaluationsServices();